<template>
  <div v-if="loading" class="fixed bg-[#ffffff50] flex justify-center items-center w-full h-full z-[1000]">
    <div
      class="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"
    ></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ loading: boolean }>();
</script>
